var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.todos),function(todo){return _c('li',{key:todo.id},[_c('router-link',{attrs:{"to":{ name: 'editItem', params: { iid: todo.id }}}},[_vm._v(_vm._s(todo.name))]),_vm._v(" - "+_vm._s(todo.todo)+" ")],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }